import { SharedEnvironment } from '@sd-portal/shared/environment';

const apphost = '__SchedulerAppFullURLWTS__';
const authhost = '__AuthServerFullURLWTS__';

export const environment: SharedEnvironment = {
  production: true,
  local: false,
  analyticsTrackingID: '__AnalyticsTrackingID__',
  sentry: {
    dsn: '__SentryDSN__',
    environment: '__SentryEnvironment__',
  },
  apihost: {
    postFlight: '__ProfileWebAPIFullURLWTS__',
    preFlight: '__ProfileWebAPIFullURLWTS__',
    profile: '__ProfileWebAPIFullURLWTS__',
    admin: '__ProfileWebAPIFullURLWTS__',
    reportsMetaData: '__ProfileWebAPIFullURLWTS__',
    search: '__ProfileWebAPIFullURLWTS__'
  },
  apiroute: {
    postFlight: '__ProfileWebAPIFullURLWTS__' + 'postflight/api/',
    preFlight: '__ProfileWebAPIFullURLWTS__' + 'preflight/api/',
    profile: '__ProfileWebAPIFullURLWTS__' + 'profile/api/',
    admin: '__ProfileWebAPIFullURLWTS__' + 'profile/api/',
    reportsMetaData: '__ProfileWebAPIFullURLWTS__' + 'profile/api/',
    search: '__ProfileWebAPIFullURLWTS__' + 'search/api/'
  },
  domainModuleRoutes: {
    profiles: '/',
    preFlight: '/',
    postFlight: '/',
    admin: '/',
    reportsMetaData: '/',
    support: '/',
    trainingVideos: '/'
  },
  reportsServerAPIHost: '__ReportServerHost__',
  appInsightsConfig: {
    instrumentationKey: '__AppInsightsKey__',
    cloudRoleName: 'SD.PPF.Web'
  },
  oidcsettings: {
    auto_clean_state_after_authentication: true,
    auto_userinfo: true,
    client_id: 'SDPortalClientAuthCodePkce',
    forbidden_route: '/forbidden',
    hd_param: '',
    log_console_debug_active: false,
    log_console_warning_active: false,
    max_id_token_iat_offset_allowed_in_seconds: 300,
    post_login_route: '/postlogin',
    post_logout_redirect_uri: apphost,
    redirect_url: `${apphost}oidccallback`,
    resource: '',
    response_type: 'code',
    scope: 'openid profile sdportalapi offline_access',
    silent_renew: false,
    silent_renew_offset_in_seconds: 0,
    silent_renew_url: `${apphost}silent-renew.html`,
    start_checksession: false,
    storage: localStorage,
    stsServer: authhost,
    trigger_authorization_result_event: false,
    unauthorized_route: '/unauthorized',
    useRefreshToken: true,
    triggerRefresh_WhenIdTokenExpired: true,
    ignoreNonceAfterRefresh: true
  },
  flightdocsAuthUrl: '__ProfileFlightdocsAuthURL__',
  flightdocsAuthRedirectUrl: '__ProfileFlightdocsAuthRedirectURL__',
  fuelerlinxAuthUrl: '__ProfileFuelerlinxAuthURL__',
  fuelerlinxAuthRedirectUrl: '__ProfileFuelerlinxAuthRedirectURL__',
  universalWeatherAuthUrl: '__ProfileUniversalAuthURL__',
  universalWeatherEnvironment: '__ProfileUniversalEnvToken__',
  universalWeatherRedirectUrl: '__ProfileUniversalAuthRedirectURL__',
  universalWeatherUIUrl: '__ProfileUniversalUIURL__',
  flightBridgeDirectLink: '__ProfileFlightBridgeRedirectURL__'
};
